export const toggleOfferTableMobileItems = () => {
    var offerTables = $(".offer-table__offers");

    if(offerTables) {
        offerTables.each(function(){
            var that = $(this);
            var tableColumns = that.find(".offer-column");
    
            tableColumns.each(function(){
                var that = $(this);
                var hiddenItemsToggleButton = that.find(".offer-table-mobile-buttons__toggle-button");
                var hiddenItemsToggleButtonText = hiddenItemsToggleButton.find("button");
                var hiddenItems = that.find(".toggle-on-smartphone");
                var hiddenContentButtonText = hiddenItemsToggleButton.attr("data-hidden-content-text");
                var shownContentButtonText = hiddenItemsToggleButton.attr("data-show-content-text");

                hiddenItemsToggleButton.off().click(function(){
                    $(this).find('button').toggleClass("rotate-icon");
                    hiddenItems.slideToggle(250);
                    if(hiddenItemsToggleButtonText.text() === hiddenContentButtonText){
                        hiddenItemsToggleButtonText.fadeOut(125, function() {
                            $(this).text(shownContentButtonText).fadeIn(125);
                        });
                    }
                    else {
                        hiddenItemsToggleButtonText.fadeOut(125, function() {
                            $(this).text(hiddenContentButtonText).fadeIn(125);
                        });
                    }

                    return false;
                })
            })
        })
    }
  }